<template>
  <div>
    <a-modal :visible="switchVisible" title="动态推送" @cancel="handleCancel" @ok="handleOk" ok-text="确认" cancel-text="取消">
      <div class="swtich-box-container">
        <div class="switch-text">
          <span>案件完成支付、待补充材料、审核不通过、递交官方、收到版权官文时，我们将提醒您。</span>
        </div>
        <div class="switch-groups">
          <div :style="{ marginRight: '10px' }">
            <span>动态推送:</span>
          </div>
          <a-checkbox value="wxMsgSwitch" @change="onChange" :checked="userConfig.wxMsgSwitch == 1 ? true : false">公众号</a-checkbox>
          <a-checkbox value="ptMsgSwitch" @change="onChange" :checked="userConfig.ptMsgSwitch == 1 ? true : false">站内信</a-checkbox>
          <a-checkbox value="smsSwitch" @change="onChange" :checked="userConfig.smsSwitch == 1 ? true : false">短信</a-checkbox>
        </div>
      </div>
      <!-- 动态拓展组件框 -->
      <transition name="expand" mode="out-in">
        <div class="expand-container">
          <div v-if="currentExpandMark == 'wxMsgSwitch'">
            <!-- 微信公众号操作容器 -->
            <div class="wx-qrcode-container">
              <a-spin :spinning="imgLoading">
                <img class="qrcode-img" :src="qrCodeInfo.imgUrl" />
                <div class="qrcode-text">扫码关注公众号 同步推送案件进展!</div>
              </a-spin>
            </div>
          </div>
          <div v-else-if="currentExpandMark == 'ptMsgSwitch'"></div>
          <div v-else-if="currentExpandMark == 'smsSwitch'">
            <div class="sms-code-container">
              <div class="input-box-container">
                <a-input class="phone-input" v-model="mobile" placeholder="请输入手机号" :maxLength="11" :disabled="codeButtonStep != 1">
                  <div slot="prefix">
                    <a-icon type="phone" />
                  </div>
                </a-input>
                <br />
              </div>
              <div class="input-box-container">
                <a-input class="code-input" v-model="smsCode" placeholder="请输入验证码" :maxLength="6" :disabled="codeButtonStep == 4">
                  <div slot="prefix">
                    <a-icon type="safety-certificate" />
                  </div>
                </a-input>
                <a-button v-if="codeButtonStep == 1 && smsCode.length != 6" @click="codePro" :disabled="mobile.length == 11 ? false : true">获取验证码</a-button>
                <a-button v-else-if="codeButtonStep == 2" disabled>{{ codeLimitCount }}秒后再次获取</a-button>
                <a-button v-else-if="(codeButtonStep == 3 || smsCode.length == 6) && codeButtonStep != 4" @click="codeCheckPro" type="primary">立即验证</a-button>
                <a-tag v-else-if="codeButtonStep == 4" color="green" disabled>验证成功</a-tag>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </a-modal>
  </div>
</template>

<script>
import { getUserConfig, getQrCodeInfo, updateUserConfig, codePro, codeCheckPro } from '@/api/user'
export default {
  props: {
    switchVisible: Boolean
  },
  data() {
    return {
      userConfig: {
        createdAt: '',
        email: '',
        emailSwitch: 0,
        id: '',
        memo: '',
        mobile: '',
        orgId: '',
        ptMsgSwitch: 1,
        smsSwitch: 0,
        updatedAt: '',
        userId: '',
        username: '',
        wxMsgSwitch: 0,
        wxOpenid: ''
      },
      qrCodeInfo: {
        imgUrl: '',
        openid: '',
        qrMark: 0,
        unionKey: ''
      },
      currentExpandMark: null,
      qrCodeInterval: null,
      smsCodeInterval: null,
      qrCodeSuccessMark: false,
      smsCodeSuccessMark: false,
      imgLoading: false,
      initWxMsgSwitch: null,
      codeButtonStep: 1,
      codeLimitCount: 60,
      smsCode: '',
      mobile: '',
      lastQrMark: null,
      openIds: [],
      initSmsSwitch: null
    }
  },
  watch: {
    switchVisible: function () {
      if (this.switchVisible == true) {
        this.getUserConfig()
      }
    },
    smsCode: function () {
      if (this.smsCode.length == 6) {
        this.codeButtonStep = 3
      }
    }
  },
  methods: {
    onChange(val) {
      const { checked, value } = val.target || {}
      this.userConfig[value] = !this.userConfig[value]
      if (value == 'wxMsgSwitch' && checked == true) {
        this.imgLoading = true
        this.currentExpandMark = 'wxMsgSwitch'
        this.userConfig.wxMsgSwitch = !this.userConfig.wxMsgSwitch ? 0 : 1
        let count = 1
        this.getQrCodeInfo()
        if (this.qrCodeInterval == null) {
          this.qrCodeInterval = setInterval(() => {
            if (count <= 99) {
              this.getQrCodeInfo()
              count++
            }
            console.log('结果轮询 qrMark:' + this.qrCodeInfo.qrMark + '  openid:' + this.qrCodeInfo.openid)
            let flag = this.qrCodeInfo.openid != '' && this.qrCodeInfo.openid != undefined && this.qrCodeInfo.openid != null
            if (this.qrCodeInfo.qrMark == 1 || flag) {
              clearInterval(this.qrCodeInterval)
              console.log('关闭轮询')
              console.log(this.qrCodeInterval)
              this.qrCodeInterval = null
              if (this.lastQrMark == 0) {
                this.$message.success('扫码成功!')
                this.currentExpandMark = ''
              } else {
                this.$message.success('您已关注!')
                setTimeout(() => {
                  this.currentExpandMark = ''
                }, 2000)
              }
              this.userConfig.wxMsgSwitch = 1
              this.userConfig.wxOpenid = this.qrCodeInfo.openid
            } else {
              this.lastQrMark = 0
            }
          }, 3500)
        }
      } else if (value == 'wxMsgSwitch' && checked == false) {
        // this.initWxMsgSwitch = 0
        this.userConfig.wxMsgSwitch = 0
        this.currentExpandMark = ''
      } else if (value == 'ptMsgSwitch') {
        this.currentExpandMark = 'ptMsgSwitch'
        this.userConfig.ptMsgSwitch = !this.userConfig.ptMsgSwitch ? 0 : 1
      } else if (value == 'smsSwitch') {
        if (checked == true) {
          this.currentExpandMark = 'smsSwitch'
          this.userConfig.smsSwitch = !this.userConfig.smsSwitch ? 0 : 1
        } else {
          this.codeButtonStep = 1
          this.currentExpandMark = ''
          this.userConfig.smsSwitch = !this.userConfig.smsSwitch ? 0 : 1
        }
      }
    },
    handleCancel() {
      if (this.qrCodeInterval != null) {
        clearInterval(this.qrCodeInterval)
      }
      this.$emit('closeSwitchBox')
    },
    handleOk() {
      if (this.qrCodeInterval != null) {
        clearInterval(this.qrCodeInterval)
      }
      if (this.userConfig.smsSwitch != this.initSmsSwitch && this.initSmsSwitch == 0 && this.codeButtonStep != 4) {
        this.$message.error('请完成短信开关验证流程!')
      } else {
        this.updateUserConfig()
        this.$emit('closeSwitchBox')
      }
    },
    async getUserConfig() {
      const res = await getUserConfig()
      console.log(res)
      this.userConfig = res.data
      this.mobile = this.userConfig.mobile
      this.initWxMsgSwitch = this.userConfig.wxMsgSwitch
      this.initSmsSwitch = this.userConfig.smsSwitch
    },
    // 获取公众号二维码
    async getQrCodeInfo() {
      const res = await getQrCodeInfo({
        validPeriodType: 'TEMP',
        expireSeconds: 7200
      })
      this.qrCodeInfo = res.data
      if (this.qrCodeInfo.imgUrl) {
        this.imgLoading = false
      }
    },
    async updateUserConfig() {
      console.log(this.userConfig)
      const res = await updateUserConfig(this.userConfig)
    },
    async codeCheckPro() {
      const res = await codeCheckPro({
        type: 'normal',
        mobile: this.mobile,
        code: this.smsCode
      })
      if (res.code == 0) {
        this.userConfig.smsSwitch = 1
        this.userConfig.mobile = this.mobile
        this.codeButtonStep = 4
      } else {
        this.userConfig.smsSwitch = 0
      }
    },
    async getWxOpenId() {
      const res = await getWxOpenId()
      this.openIds = res.data
    },
    async codePro() {
      const res = await codePro({
        type: 'normal',
        mobile: this.mobile
      })
      const { code } = res || {}
      if (code == 0) {
        this.codeLimitCount = 60
        this.codeButtonStep = 2
        this.smsCodeInterval = setInterval(() => {
          this.codeLimitCount--
          if (this.codeLimitCount === 0) {
            clearInterval(this.smsCodeInterval)
            this.codeButtonStep = 1
          }
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.swtich-box-container {
  display: flex;
  flex-direction: column;
}
.switch-text {
  background-color: #d2effd;
  width: 70%;
  margin: 0 auto;
  margin-bottom: 10px;
}
.switch-groups {
  line-height: 20px;
  display: flex;
  flex-direction: row;
  /* justify-content: space-around; */
  margin: 0 auto;
}
.ant-tabs-nav-scroll {
  display: none;
}
.ant-tabs-bar {
  border-bottom: 0px solid #e8e8e8 !important;
}
.expand-container .ant-tabs-ink-bar {
  visibility: hidden !important;
  outline: #fff !important;
  background-color: #fff !important;
}
.wx-qrcode-container {
  text-align: center;
  display: flex;
  flex-direction: column;
}
.qrcode-img {
  margin: 0 auto;
  height: 180px;
  width: 180px;
}
.qrcode-text {
  margin: 0 auto;
}
.sms-code-container {
  text-align: center;
}
.input-box-container {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  line-height: 65px;
  align-items: center;
  margin-top: 5px;
}
.input-box-container .ant-tag {
  line-height: 30px !important;
  padding: 0px 15px !important;
  margin: 0 auto;
}
.phone-input {
  margin: 0 auto;
}
.code-input {
  margin: 0 auto;
}
.expand-enter-active,
.expand-leave-active {
  transition: all 1s;
}
.expand-enter,
.expand-leave-to {
  opacity: 0;
}
</style>
